module.exports = [{"code":"en","name":"English"},{"code":"es","name":"Spanish"},{"code":"du","name":"German"},{"code":"ru","name":"Russian"},{"code":"ar","name":"Arabic"},{"code":"fa","name":"Farsi"},{"code":"cn","name":"Chinese"},{"code":"ro","name":"Romanian"}]


//////////////////
// WEBPACK FOOTER
// ./static/languages.json
// module id = 265
// module chunks = 6